__turbopack_context__.v({
  "heading": "SideCtaSidebar-module__QIZQ0q__heading",
  "sidebar": "SideCtaSidebar-module__QIZQ0q__sidebar",
  "stickyInner": "SideCtaSidebar-module__QIZQ0q__stickyInner",
});
